export default __webpack_public_path__ + "static/944-b0f2581faa9c6efe351241eb10cbd601.gif";